import React, { Component } from 'react';
import Helmet from "react-helmet";

import Login from '../../components/login/';

const LoginPage = () => (
	<div className="login-index">
		<Helmet>
			<title>ИРМ - Авторизация по карте</title>
		</Helmet>
		<Login />
	</div> 
)

export default LoginPage;


// WEBPACK FOOTER //
// ./src/routes/login/card.jsx